import { getServices } from "../../../api/getServices";
import { AppAction, AppThunkAction } from "../types";
import { UserState } from "../types/UserState";

export enum ActionKey {
  SET_USER = "SET_USER",
}

interface SetUserAction
  extends AppAction<ActionKey.SET_USER, { user: UserState }> {}

export type ViewerAction = SetUserAction;

const setUser = (user: UserState): SetUserAction => ({
  type: ActionKey.SET_USER,
  payload: {
    user,
  },
});

/**
 * Updates app state with the ID of the current viewing user.
 *
 * @param services Services API
 */
export const fetchViewer =
  (): AppThunkAction<Promise<void>> => async dispatch => {
    const services = getServices();
    const user = await services.usersClient.usersService.getCurrentUser({
      includeGroups: false,
      includeLogins: false,
    });

    const role = !user?.id ? "anonymous" : user.isAdmin ? "admin" : "user";
    dispatch(
      setUser({
        id: (user && user.id) || 0,
        username: (user && user.userName) || "",
        name: (user && user.displayName) || "",
        thumbnail: (user && user.thumbnailUrl) || "",
        profileUrl: user?.profileUrl ?? "",
        isPhoneVerified: (user && user.isPhoneVerified) || false,
        role,
      })
    );
  };
